"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationModal = ConfirmationModal;
const react_1 = __importDefault(require("react"));
const modal_types_1 = require("./modal-types");
const window_1 = require("../../contexts/window");
const controls_1 = require("../controls");
const constants_1 = require("../../modals/constants");
const modal_base_1 = require("./modal-base");
function ConfirmationModal({ type, acceptText, rejectText, acceptClassNames, rejectClassNames, accept, reject, text, close, title }) {
    const messageType = modal_types_1.messageTypes[type] || modal_types_1.messageTypes.information;
    const acceptClassNamesUsed = `btn btn-${acceptClassNames || 'primary'}`;
    const rejectClassNamesUsed = `btn btn-${rejectClassNames || 'secondary'}`;
    const { isMobile } = (0, window_1.useWindow)();
    const widthStyles = isMobile ? { maxWidth: '480px' } : { maxWidth: '500px' };
    const confirmationStyles = Object.assign(Object.assign(Object.assign({}, constants_1.messageStyles), widthStyles), { zIndex: '1046' });
    const handleReject = () => {
        close();
        if (reject) {
            reject();
        }
    };
    const handleAccept = () => {
        close();
        if (accept) {
            accept();
        }
    };
    return (react_1.default.createElement(modal_base_1.ModalBase, { text: text, messageType: messageType, close: close, dialogStyles: confirmationStyles, showFooter: true, title: title },
        react_1.default.createElement(controls_1.Button, { id: 'confirmation-secondary', classes: rejectClassNamesUsed, text: rejectText, onClick: handleReject, disabled: false }),
        react_1.default.createElement(controls_1.Button, { id: 'confirmation-primary', classes: acceptClassNamesUsed, text: acceptText, onClick: handleAccept, disabled: false })));
}
